import Box from '@mui/material/Box';
import clsx from 'clsx';
import { DayHeaderContentArg } from '@fullcalendar/react';
import { CalendarDateService } from '@uplift/services';
import { TimeRange } from '@uplift/types';
import { makeStyles } from 'tss-react/mui';
import { DateFormats } from '@uplift/constants';


export const UnavailableBlock = () => {
  return (
    <Box style={{ backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 6, padding: '0px 10px', height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' }} width="100%">
      Unavailable
    </Box>
  );
};

const useOverridesBlockStyles = makeStyles()(theme => ({
  root: {
    textAlign: 'left',
    paddingLeft: '6px',
    paddingBottom: '4px',
    color: theme.palette.info.dark,
    textTransform: 'none',
    width: '100%',
    position: 'relative',
    userSelect: 'none',

    '&:before': {
      content: '" "',
      position: 'absolute',
      left: '-1px',
      bottom: '-1px',
      height: '4px',
      width: 'calc(100% + 2px)',
      background: theme.palette.info.light,
    }
  },
}));

export const OverridesBlock = () => {
  const { classes } = useOverridesBlockStyles();

  return (
    <Box className={classes.root}>
      Date Override
    </Box>
  );
};


// export const dayHeaderFormatter = (arg: VerboseFormattingArg, overrides: Record<string, TimeRange[]> = {}) => {
export const DayHeaderContent = ({ arg, overrides }: { arg: DayHeaderContentArg; overrides: Record<string, TimeRange[]> }) => {
  // need to convert date to utc because arg.date.marker is a native Date
  // it was created in utc but as it is native Date
  // system timezone was applied to it (-04:00 for example) and it was shifted to previous day
  // 2021-09-12T00:00:00+00:00 -> 2021-09-11T20:00:00-04:00
  const date = CalendarDateService.date(arg.date).utc();
  const overrideKey = date.format(DateFormats.ISO_DATE);
  const hasOverride = overrides[overrideKey];

  return (
    <Box display="flex" flexDirection="column" width="100%" alignItems="center" gap="4px" bgcolor="#fff" zIndex={2} height="100%">
      <Box display="flex" alignItems="center" gap="18px" flex={1}>
        <Box className="fc-col-header-cell-cushion-weekday">{date.format('ddd')}</Box>
        <Box className={clsx('fc-col-header-cell-cushion-date', {
          'additional-space-left': date.date() > 10 && date.date() % 10 === 1,
          'additional-space-right': 9 < date.date() && date.date() < 20,
        })}
        >{date.format('D')}</Box>
      </Box>
      <Box />
      {hasOverride ? <OverridesBlock /> : <Box height="19px" />}
    </Box>
  );
};
